import { useCallback, useState } from 'react'

export function useToggleBooleanMap() {
  const [boolMap, setBoolMap] = useState<Map<string, boolean>>(new Map())
  const toggleBool = useCallback(
    (key: string) =>
      setBoolMap((prev) => new Map(prev).set(key, !prev.get(key))),
    [],
  )

  return [boolMap, toggleBool] as const
}
